module.exports = __webpack_public_path__ + "img/calculator.8912a166.svg";